import * as Sentry from "@sentry/react";

export const useExceptionLogging = () => {
  const logException = (
    error: Error,
    tags?: { [tag: string]: string | number | boolean },
  ) => {
    Sentry.captureException(error, { tags });
    window.LogRocket?.captureException(error, { tags });
  };

  return { logException };
};
